<div *ngIf="widgetTitle" class="widget__header">
    <h4>{{ widgetTitle }}</h4>
</div>
<div class="widget-tags__body tags">
    <div class="tags__list">
        <a href="">Promotion</a>
        <a href="">Power Tool</a>
        <a href="">New Arrivals</a>
        <a href="">Screwdriver</a>
        <a href="">Wrench</a>
        <a href="">Mounts</a>
        <a href="">Electrodes</a>
        <a href="">Chainsaws</a>
        <a href="">Manometers</a>
        <a href="">Nails</a>
        <a href="">Air Guns</a>
        <a href="">Cutting Discs</a>
    </div>
</div>
